import { RichiestaDTO, SezioneDTO, apiClient } from '@framework/api-client';
import {
  AllRootsContextProvider,
  AsyncServicesEngineContextProvider,
} from '@framework/engine';
import * as React from 'react';
import { FillableSubmissionContextProvider } from './FillableSubmissionContext';
import { useFillableAllRoots } from './hooks/useFillableAllRoots';
import { useFillableAsyncServices } from './hooks/useFillableAsyncServices';

export interface IEngineFillableContextProviderProps {
  sections: SezioneDTO[];
  children: React.ReactNode;
  /**
   * In caso di compilazione `Frontoffice` è necessario passare la richiesta
   * che si sta compilando.
   */
  submission?: RichiestaDTO | null;

  /** ID Richiesta - Modulo */
  submissionModuleId?: string | null;
}

/**
 * Si occupa di collegare un Form Compilabile (gestito da `@framework/engine`)
 * con il mondo esterno, in particolare con il mondo di `@framework/api-client`.
 *
 * L'engine infatti è _agnostico_ rispetto alle API, ai DTO e al contesto d'uso.
 * Usa solo un `IEngineSection` che è un'astrazione.
 *
 * Questo componente si occupa di collegare l'engine quindi con le API, le sezioni
 * reali, ecc. nella fase di **compilazione**.
 */
export function EngineFillableContextProvider(
  props: IEngineFillableContextProviderProps,
) {
  const { sections, submission, submissionModuleId } = props;

  // Servizi asincroni e root. In generale configuriamo qui tutte le
  // informazioni di compilazione per l'Engine
  const asyncServices = useFillableAsyncServices();
  const allRoots = useFillableAllRoots(sections);

  return (
    <AllRootsContextProvider allRoots={allRoots}>
      <AsyncServicesEngineContextProvider
        axiosClient={apiClient}
        services={asyncServices}
      >
        <FillableSubmissionContextProvider
          submission={submission}
          submissionModuleId={submissionModuleId}
        >
          {props.children}
        </FillableSubmissionContextProvider>
      </AsyncServicesEngineContextProvider>
    </AllRootsContextProvider>
  );
}
